export default "__VITE_ASSET__CsMy4l84__"